import { Injectable, signal, Signal } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GearType, Vehicle } from '@softapps/werkstatt/garage-core';
import { Validators } from '@softline/ui-core';
import { CustomGearService } from './custom-gear.service';

@Injectable()
export class ToolService extends CustomGearService<Vehicle> {
  override type: Signal<GearType> = signal('tool');
  override title: Signal<string> = signal('Kleingeräte Verwaltung');

  createForm() {
    return new FormGroup({
      id: new FormControl<number | null>(null),
      number: new FormControl<number | null>(null),
      name: new FormControl<string | null>(null),
      tool: new FormGroup({
        description: new FormControl<string | null>(null),
        id: new FormControl<number | null>(null),
        pin: new FormControl<string | null>(null),
        product: new FormControl<object | null>(null),
        readyForOperation: new FormControl<boolean>(false),
        serialNumber: new FormControl<string>('', {
          nonNullable: true,
          validators: [Validators.required()],
        }),
      }),
      customerInformation: new FormGroup({
        customer: new FormControl<object | null>(null),
        salesOrganisation: new FormControl<object | null>({
          nonNullable: true,
          validators: [Validators.required()],
        }),
        active: new FormControl<boolean>(true),
      }),
      type: new FormGroup({
        euroTaxCode: new FormControl<string | null>(null),
        vehicleType: new FormControl<object | null>(null),
        brand: new FormControl<string | null>(null),
        tradeName: new FormControl<string>('', {
          nonNullable: true,
          validators: [Validators.required()],
        }),
        variant: new FormControl<string | null>(null),
        structure: new FormControl<string | null>(null),
      }),
      archiveKey: new FormControl<object | null>(null),
    });
  }
}
